export default __webpack_public_path__ + "static/media/activity-exercise-icon.2f76b324.svg";